export default {
  methods: {
    /**
     * 物料的单位换算
     * @param {object} item 完整的物料对象
     * @param {string} numKey 数量对应的字段名
     * @returns 换算后的数量
     */
    convertGoodsUnit(item, numKey) {
      let msg = '';
      let num = item[numKey];
      // num为出库数量，conversionRatio为换算比例，conversionUnitName为换算单位
      // 后端返回的数据各种异常，要么null，要么-1，简单处理下目前碰到的几种异常值
      if (!num) return msg;
      if (!item.conversionUnitName || !item.conversionRatio || item.conversionRatio < 0) {
        return num + item.measuringUnitName;
      }
      const quotient = Math.floor(num / item.conversionRatio);
      const remainder = num % item.conversionRatio;
      if (quotient > 0) {
        msg = quotient + item.conversionUnitName;
        if (remainder > 0) {
          msg += remainder + item.measuringUnitName;
        }
      } else {
        msg = remainder + item.measuringUnitName;
      }
      return msg;
    },
  },
};
